<template>
  <vl-properties-list>
    <vl-properties-label>{{ $t('deliveryprocessdefinition.detail.id') }}</vl-properties-label>
    <vl-properties-data>{{ detail.id }}</vl-properties-data>
    <vl-properties-label>{{ $t('deliveryprocessdefinition.detail.label') }}</vl-properties-label>
    <vl-properties-data>{{ detail.label }}</vl-properties-data>
    <vl-properties-label>{{ $t('deliveryprocessdefinition.detail.description') }}</vl-properties-label>
    <vl-properties-data>{{ detail.description }}</vl-properties-data>
    <vl-properties-label>{{ $t('deliveryprocessdefinition.detail.organisation') }}</vl-properties-label>
    <vl-properties-data>{{ detail.organisation }} ({{ detail.ovoNumber }})</vl-properties-data>
    <vl-properties-label>{{ $t('entitymodel.detail.status') }}</vl-properties-label>
    <vl-properties-data>{{ getStatusLabel(detail.statusId) }}</vl-properties-data>
  </vl-properties-list>
</template>

<script lang="ts" setup>
import { DeliveryProcessDefinitionDetailDto } from '@/api/backoffice/clients';
import { useDeliveryProcessDefinitionDetailStore } from '@/modules/configuration/store/delivery-process-definition/delivery-process-definition-detail.store';
import { computed } from 'vue';
import { ENUM_StatusTypes } from '../../common';

const store = useDeliveryProcessDefinitionDetailStore();

const detail = computed((): DeliveryProcessDefinitionDetailDto => {
  return store.detail;
});

const getStatusLabel = (statusId: number): string => {
  return Object.values(ENUM_StatusTypes).find((status) => status.id === statusId)?.name ?? '-';
};
</script>
